export const AGENT_API_URL = import.meta.env.VITE_AGENT_API_URL ?? 'http://localhost:8080'
